module.exports = __webpack_public_path__ + "static/media/gif2.ab0b30d5.gif";